import React, { Component } from 'react';
import { observer } from 'mobx-react';
import axios from 'axios';
import { Row, Col, Button, Label, Modal } from 'reactstrap';
import { Form } from '@availity/form';
import { NavLink, Navigate } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import ErrorPopup from '../ErrorWindow/error-popup';
import housingstore from '../stores/housingstore';
import CustomProgressBar from '../../Common/components/CustomProgressBar';
import withNavigate from '../../Common/components/withNavigate';


function PageForPrint() {
  const {
    currentDate,
    memberInfo,
    healthNeedCat,
    riskFactorsCategories,
    instSettingsCategories,
    resCareFacilityCategories,
    institutionalSettingsRadio,
    multiResidentialCareRadio,
    multiInstSettingsRadio,
    multiInHomeCareRadio,
    additionalDetails,
    countDetails,
    strengthsCategories,
    otherStrengths,
    housingPreferenceCat,
    closeToCat,
    otherCloseTo,
    livingSpaceCat,
    housingPreferenceDescription,
    publicTrasportationRadio,
    vehicleRadio,
    transportationDescription,
    individualHousingRadio,
    rentalAssistanceCat,
    otherRentalAssistanceDetails,
    rentalSubsidyCategories,
    otherRentalSubsidyDetails,
    continuumOfCareCat,
    deptOfCommerceSubsidized,
    otherHUDOrUSDASubsidy,
    countyOrCityProgram,
    otherProgramsDetails,
    otherContinuumOfCareDetails,
    assessmentReporter,
    assessmentSupervisor,
    enrolleeInformation,
    totalIncome,
    housingType,
    isClientHoused,
    dateHoused,
    employmentCategories,
    incomeCategories,
    incomeOther,
    homelessRadio,
    homelessOther,
    currentHousingType,
    currentHousingTypeOther,
    housingAtRisk,
    housingAtRiskReasons,
    housingAtRiskOther,
    housingGoalsSet,
    housingGoalsCount,
    housingGoalsConfidence,
    preferredHousingType,
    preferredHousingTypeOther,
    preferredHousingLocation,
    personalInformationObj,
    ahahChronicHomelessness,
    ahahFreqResCareStay,
    ahahLengthyInstContacts,
    // documentCategories,
    // suppDocRadio,
    attachments,
    documentNotes,
    assessmentCategories,
    signatureCategories
  } = housingstore;

  const {
    ahahChronicRadio,
    ahahChronicFirstLast,
  } = ahahChronicHomelessness;

  const {
    ahahFreqResRadio,
    ahahFreqResStayFirstLast
  } = ahahFreqResCareStay;

  const {
    ahahLengthyRadio,
    ahahLengthyFirstLast
  } = ahahLengthyInstContacts;

  const iframeStyle = {
    height: "0px",
    width: "0px",
    position: "absolute"
  }

  const provAgencyName = housingstore.getProviderAgencyName(assessmentReporter);

  return (
    <>
      <iframe title="Review_Frame" id="ifmcontentstoprint" style={iframeStyle} />
      <NavLink exact to="/signature" className={'btn btn-link backBtn'}>
        <i className="icon icon-left-small" />
        Back
      </NavLink>
      <div id="divcontents" className="border-form">
        <Row>
          <Col sm="7">
            <h2 className="poppinsH2">
              Review and Submit
            </h2>
          </Col>
        </Row>
        <div className="spacer-48" />
        <Row>
          <Col sm="10">
            <h3>
              Potential Enrollee Information
            </h3>
          </Col>
        </Row>
        <div className="spacer" />

        {
          memberInfo.initReauth &&
          <div className="label-font">
            <i className="icon icon-ok" />
            {memberInfo.initReauth}
          </div>
        }

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewLast">
              <b>Last Name</b>
            </Label>
            <p name="memReviewLast" className="label-font">
              {memberInfo.memLast}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewMiddleInitial">
              <b>Middle Initial</b>
            </Label>
            <p name="memReviewMiddleInitial" className="label-font">
              {memberInfo.memMiddle }
            </p>
          </Col>          
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewFirst">
              <b>First Name</b>
            </Label>
            <p name="memReviewFirst" className="label-font">
              {memberInfo.memFirst}
            </p>
          </Col>

        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className='label-font' htmlFor='memReviewPreferredName'>
              <b>Preferred Name</b>
            </Label>
            <p name="memReviewPreferredName">
              {memberInfo.memberPrefName}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewGender">
              <b>Gender</b>
            </Label>
            <p name="memReviewGender" className="label-font">
              {memberInfo.memGender }
            </p>
          </Col>          
          <Col sm="4">
              <Label className="label-font" htmlFor="memReviewDOB">
                <b>Date of Birth</b>
              </Label>
              <p name="memReviewDOB" className="label-font">
                {memberInfo.memDOB !== '' ? moment(memberInfo.memDOB).format("MM/DD/YYYY") : ''}
              </p>
            </Col>
        </Row>
        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewDate">
              <b>Date Received</b>
            </Label>
            <p name="memReviewDate" className="label-font">
              {currentDate}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memAssessCompleted">
              <b>Date Assessment Completed</b>
            </Label>
            <p name="memAssessCompleted" className="label-font">
              {memberInfo.dateAssessmentComp !== '' ? moment(memberInfo.dateAssessmentComp).format("MM/DD/YYYY") : ''}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewAddr">
              <b>Is experiencing homelessness?</b>
            </Label>
            <p name="memReviewAddr" className="label-font">
              {memberInfo.isHomeless}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewAddr">
              <b>Would the potential enrollee like to be considered for the AHAH Rental Assistance Program (AHAH-RAP)?</b>
            </Label>
            <p name="memReviewAddr" className="label-font">
              {memberInfo.isEnrolleeEligibleForAHAH}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="8">
            <Label className="label-font" htmlFor="memReviewAddr">
              <b>Address</b>
            </Label>
            <p name="memReviewAddr" className="label-font">
              {
                `${memberInfo.memAddr ? `${memberInfo.memAddr}, ` : ''} ${memberInfo.memCity ? `${memberInfo.memCity}, ` : ''} ${memberInfo.memCounty? `${memberInfo.memCounty}, ` : ''} ${memberInfo.memState} ${memberInfo.memZip}`
              }
            </p>
          </Col>
        </Row>
        
        <div className="spacer" />

        <Row>        
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewEmail">
              <b>Email</b>
            </Label>
            <p name="memReviewEmail" className="label-font">
              {memberInfo.memEmail}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewProvOne">
              <b>ProviderOne ID</b>
            </Label>
            <p name="memReviewProvOne" className="label-font">
              {memberInfo.memProvOne}WA
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewPhone">
              <b>Phone</b>
            </Label>
            <p name="memReviewPhone" className="label-font">
              {memberInfo.memPhone}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewPhoneType">
              <b>Phone Number Type</b>
            </Label>
            <p name="memReviewPhoneType" className="label-font">
              {memberInfo.phoneType}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewNameOfContact">
              <b>Name</b>
            </Label>
            <p name="memReviewNameOfContact" className="label-font">
              {memberInfo.nameOfContact}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewTribe">
              <h5>
                <b>Member of recognized tribe</b>
              </h5>
            </Label>
            <p name="memReviewTribe" className="label-font">
              {memberInfo.memTribe}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewTribeDetails">
              <h5>
                <b>Name of recognized tribe</b>
              </h5>
            </Label>
            <p name="memReviewTribeDetails" className="label-font">
              {memberInfo.tribeDetails}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewVet">
              <h5>
                <b>Veteran</b>
              </h5>
            </Label>
            <p name="memReviewVet" className="label-font">
              {memberInfo.memVet}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="memReviewVetDetails">
              <h5>
                <b>Military Branch</b>
              </h5>
            </Label>
            <p name="memReviewVetDetails" className="label-font">
              {memberInfo.vetDetails}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <hr className="mtb-35" />

        <Row>
          <Col sm="10">
            <h2 className="poppinsH2">
              Complex needs eligibility requirements
            </h2>
          </Col>
        </Row>

        <div className="spacer" />

        <h3>
          Health needs
        </h3>

        <div className="spacer" />

        <div name="healthNeedsReview" className="label-font">
          {
            healthNeedCat.indexOf('opt1') >= 0 ?
              `Mental health need where there is a need for improvement, stabilization or prevention of
             deterioration to functioning resulting from the presence of a mental illness (as determined 
              by a licensed behavioral health agency)`
              :
              null
          }
          <div className="spacer" />
          {
            healthNeedCat.indexOf('opt2') >= 0 ?
              `Diagnosed with a substance use disorder (SUD), by meeting a one or higher level on the 
            American Society of Addiction Medicine (ASAM) Criteria (as determined by a licensed behavioral health agency)`
              :
              null
          }
          <div className="spacer" />
          {
            healthNeedCat.indexOf('opt3') >= 0 ?
              `Needs assistance with three or more activities of daily living (ADL) or one or more hands-on ADL as determined
             by a Comprehensive Assessment and Reporting Evaluation (CARE)`
              :
              null
          }
          <div className="spacer" />
          {
            healthNeedCat.indexOf('opt4') >= 0 ?
              `The client is a homeless individual with a disability, determined by a coordinated entry assessment. (Individual assessed to have a complex health need, which is defined as
              as a long continuing or indefinite physical condition requiring improvement, stablilization or prevention of deterioration of functioning [including ability to live independently without support])`
              :
              null
          }
        </div>
        <Row>
          <Col sm="10">
            <h3>
              Risk factors
            </h3>
          </Col>
        </Row>
        {
          riskFactorsCategories.indexOf('Chronically Homeless') >= 0 ?
            <>
              <p className="label-font">
                {
                  `Chronically homeless: an individual with a disabling condition who has been homeless for 
                a period of at least one year, or an individual with a disabling condition who has had at least
                four episodes of homelessness, as long as the combined occasions equal at least 12 months.`
                }
              </p>
              <div className="spacer" />
            </>
            :
            null
        }
        {
          riskFactorsCategories.indexOf('Institutional Contacts') >= 0 ?
            <>
              <p className="label-font">
                {
                  `Frequent or lengthy institutional contacts (frequent, as in two or more instances in the 
                past 12 months, or lengthy, as in lasting 90 days or more)`
                }
              </p>
              <div className="spacer" />
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="riskReviewInstSettings">
                    <b>
                      Is the client transitioning out of an institutional setting?
                  </b>
                  </Label>
                  <p name="riskReviewInstSettings" className="label-font">
                    {institutionalSettingsRadio}
                  </p>
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="riskReviewSettings">
                    <b>
                      Institutional setting(s)
                  </b>
                  </Label>
                  <div name="riskReviewSettings" className="d-flex flex-column label-font">
                    <div>{instSettingsCategories.indexOf('Nursing') >= 0 ? 'Nursing' : ''}</div>
                    <div>{instSettingsCategories.indexOf('Inpatient psychiatric hospital') >= 0 ? 'Inpatient psychiatric hospital' : ''}</div>
                    <div>{instSettingsCategories.indexOf('Inpatient medical hospital') >= 0 ? 'Inpatient medical hospital' : ''}</div>
                    <div>{instSettingsCategories.indexOf('Correctional program or institution') >= 0 ? 'Correctional program or institution' : ''}</div>
                    <div>{instSettingsCategories.indexOf('Foster care facility or other youth facility') >= 0 ? 'Foster care facility or other youth facility' : ''}</div>
                  </div>
                </Col>
                <Col sm="4">
                  <Label className="label-font" htmlFor="riskReviewContacts">
                    <b>
                      Has the client resided within one of the previously listed institutional settings multiple times in the past year?
                  </b>
                  </Label>
                  <p name="riskReviewContacts" className="label-font">
                    {multiInstSettingsRadio}
                  </p>
                </Col>
              </Row>
              <Row>
                {
                  multiInstSettingsRadio === "Yes" ?
                    <Col sm="4">
                      <Label className="label-font" htmlFor="riskReviewTimes">
                        <b>
                          Number of times
                    </b>
                      </Label>
                      <p name="riskReviewTimes" className="label-font">
                        {countDetails}
                      </p>
                    </Col>
                    :
                    null
                }
              </Row>
              <div className="spacer" />
            </>
            :
            null
        }
        {
          riskFactorsCategories.indexOf('Residential Care') >= 0 ?
            <>
              <p className="label-font">
                {
                  `Frequent residential care stays (two or more occurrences in the past 12 months)`
                }
              </p>
              <div className="spacer" />
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="riskReviewResStay">
                    <b>
                      Has the client resided within a residential care facility two or more times in the past 12 months?
                  </b>
                  </Label>
                  <p name="riskReviewResStay" className="label-font">
                    {multiResidentialCareRadio}
                  </p>
                  <div name="riskReviewResStay" className="label-font">
                    {
                      multiResidentialCareRadio === 'Yes' ?
                        <div className="d-flex flex-column label-font">
                          <div>{resCareFacilityCategories.indexOf('Evaluation and treatment facility') >= 0 ? 'Evaluation and treatment facility' : ''}</div>
                          <div>{resCareFacilityCategories.indexOf('Detox center') >= 0 ? 'Detox center' : ''}</div>
                          <div>{resCareFacilityCategories.indexOf('Inpatient substance use treatment facility') >= 0 ? 'Inpatient substance use treatment facility' : ''}</div>
                          <div>{resCareFacilityCategories.indexOf('Adult residential care, assisted living or adult family home (AFH)') >= 0 ? 'Adult residential care, assisted living or adult family home (AFH)' : ''}</div>
                        </div>
                        :
                        null
                    }
                  </div>
                </Col>
              </Row>
              <div className="spacer" />
            </>
            :
            null
        }
        {
          riskFactorsCategories.indexOf('In Home Care') >= 0 ?
            <>
              <p className="label-font">
                {`Frequent turnover of in-home caregivers (three or more occurrences in the past 12 months)`}
              </p>
              <div className="spacer" />
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="riskReviewTurnover">
                    <b>
                      Within the last 12 months, has the client used three (or more) different in-home caregiver providers (Please provide supporting documentation with the assessment)?
                  </b>
                  </Label>
                  <p name="riskReviewTurnover" className="label-font">
                    {multiInHomeCareRadio}
                  </p>
                </Col>
              </Row>
              <div className="spacer" />
            </>
            :
            null
        }
        {
          riskFactorsCategories.indexOf('Prism Score') >= 0 ?
            <>
              <p className="label-font">
                PRISM score (1.5 or above) (Contact the TPA, MCO, BHO, Health Home or HCS case manager to obtain the PRISM risk score)
            </p>
              <div className="spacer" />
            </>
            :
            null
        }
        <Row>
          <Col sm="6">
            <Label className="label-font" htmlFor="riskReviewAdditional">
              <b>
                Additional details on risk factors
              </b>
            </Label>
            <p className="label-font" name="riskReviewAdditional">
              {additionalDetails}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <hr className="mtb-35" />

        <Row>
          <Col sm="10">
            <h2 className="poppinsH2">
              Housing assessment
            </h2>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewEmpStat">
              <h5>
                <b>
                  Employment status
                </b>
              </h5>
            </Label>
            <div className="d-flex flex-column label-font">
              <div>{employmentCategories.indexOf('Unemployed') >= 0 ? 'Unemployed' : ''}</div>
              <div>{employmentCategories.indexOf('Employed part time') >= 0 ? 'Employed part time' : ''}</div>
              <div>{employmentCategories.indexOf('Employed full time') >= 0 ? 'Employed full time' : ''}</div>
              <div>{employmentCategories.indexOf('Nonpaid employment activities') >= 0 ? 'Nonpaid employment activities' : ''}</div>
              <div>{employmentCategories.indexOf('Enrolled in training/education program') >= 0 ? 'Enrolled in training/education program' : ''}</div>
            </div>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewIncome">
              <h5>
                <b>
                  Income source
                </b>
              </h5>
            </Label>
            <div className="d-flex flex-column label-font">
              <div>{incomeCategories.indexOf('Social Security (SSA)') >= 0 ? 'Social Security (SSA)' : ''}</div>
              <div>{incomeCategories.indexOf('Pension') >= 0 ? 'Pension' : ''}</div>
              <div>{incomeCategories.indexOf('Supplemental Security Income (SSI)') >= 0 ? 'Supplemental Security Income (SSI)' : ''}</div>
              <div>{incomeCategories.indexOf('Social Security Disability Insurance (SSDI)') >= 0 ? 'Social Security Disability Insurance (SSDI)' : ''}</div>
              <div>{incomeCategories.indexOf('Temporary Assistance for Needy Families (TANF)') >= 0 ? 'Temporary Assistance for Needy Families (TANF)' : ''}</div>
              <div>{incomeCategories.indexOf('Housing and Essential Needs (HEN)') >= 0 ? 'Housing and Essential Needs (HEN)' : ''}</div>
              <div>{incomeCategories.indexOf('Aged, Blind, or Disabled (ABD)') >= 0 ? 'Aged, Blind, or Disabled (ABD)' : ''}</div>
              <div>{incomeCategories.indexOf('Employment') >= 0 ? 'Employment' : ''}</div>
              <div>{incomeCategories.indexOf('None') >= 0 ? 'None' : ''}</div>
              <div>{incomeCategories.indexOf('Other') >= 0 ? 'Other' : ''}</div>
              <div>{incomeOther}</div>
            </div>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewTotIncome">
              <h5>
                <b>
                  Total Income
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewTotIncome">
              {totalIncome}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewHousingType">
              <h5>
                <b>
                  Housing
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewHousingType">
              {housingType}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewIsClientHoused">
              <h5>
                <b>
                  Is the client housed?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewIsClientHoused">
              {isClientHoused}
            </p>
          </Col>
          {isClientHoused === 'Yes' && dateHoused && (
            <Col sm="4">
              <Label className="label-font" htmlFor="housingReviewDateHoused">
                <h5>
                  <b>
                    What date did they get housed?
                  </b>
                </h5>
              </Label>
              <p className="label-font" name="housingReviewDateHoused">
                {moment(dateHoused).format("MM/DD/YYYY")}
              </p>
            </Col>
          )}
        </Row>

        {isClientHoused === 'Yes' && currentHousingType && (
          <>
            <div className="spacer" />
            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="currentHousingTypeReview">
                  <h5>
                    <b>
                      What type of housing does the client currently live in?
                    </b>
                  </h5>
                </Label>
                <p className="label-font" name="currentHousingTypeReview">
                  {currentHousingType}
                </p>
                {currentHousingType === 'Other' && currentHousingTypeOther && (
                  <p className="label-font">
                    {currentHousingTypeOther}
                  </p>
                )}
              </Col>
            </Row>
          </>
        )}

        {isClientHoused === 'Yes' && housingAtRisk && (
          <>
            <div className="spacer" />
            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingAtRiskReview">
                  <h5>
                    <b>
                      Is the client's current housing at risk?
                    </b>
                  </h5>
                </Label>
                <p className="label-font" name="housingAtRiskReview">
                  {housingAtRisk}
                </p>
              </Col>
            </Row>
            {housingAtRisk === 'Yes' && housingAtRiskReasons && housingAtRiskReasons.length > 0 && (
              <Row>
                <Col sm="4">
                  <Label className="label-font">
                    <b>Reasons:</b>
                  </Label>
                  <div className="d-flex flex-column label-font">
                    {housingAtRiskReasons.filter(reason => reason !== 'Other').map((reason, index) => (
                      <div key={index}>{reason}</div>
                    ))}
                    {housingAtRiskReasons.indexOf('Other') >= 0 && (
                      <div>Other</div>
                    )}
                    {housingAtRiskReasons.indexOf('Other') >= 0 && housingAtRiskOther && (
                      <div>{housingAtRiskOther}</div>
                    )}
                  </div>
                </Col>
              </Row>
            )}
          </>
        )}

        <div className="spacer" />

        {
          homelessRadio ?
            <>
              <Label className="label-font" htmlFor="homelessOption">
                <b>
                  Homeless Option
              </b>
              </Label>
              <p className="label-font" name="homelessOption">
                {homelessRadio}
              </p>
              <p className="label-font" name="homelessOption">
                {homelessOther}
              </p>

              <div className="spacer" />
            </>
            :
            null
        }


        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewStrengths">
              <h5>
                <b>
                  Strengths
                </b>
              </h5>
            </Label>
            <div className="d-flex flex-column label-font">
              <div>{strengthsCategories.indexOf('Arranging apartment repairs') >= 0 ? 'Arranging apartment repairs' : ''}</div>
              <div>{strengthsCategories.indexOf('Desire to work or engage in community activities') >= 0 ? 'Desire to work or engage in community activities' : ''}</div>
              <div>{strengthsCategories.indexOf('Driving/using public transportation') >= 0 ? 'Driving/using public transportation' : ''}</div>
              <div>{strengthsCategories.indexOf('Filling prescriptions') >= 0 ? 'Filling prescriptions' : ''}</div>
              <div>{strengthsCategories.indexOf('Getting along with neighbors, landlords, etc.') >= 0 ? 'Getting along with neighbors, landlords, etc.' : ''}</div>
              <div>{strengthsCategories.indexOf('Housekeeping') >= 0 ? 'Housekeeping' : ''}</div>
              <div>{strengthsCategories.indexOf('Hygiene') >= 0 ? 'Hygiene' : ''}</div>
              <div>{strengthsCategories.indexOf('Lease compliance') >= 0 ? 'Lease compliance' : ''}</div>

              <div>{strengthsCategories.indexOf('Long-term rental history') >= 0 ? 'Long-term rental history' : ''}</div>
              <div>{strengthsCategories.indexOf('Maintaining benefits') >= 0 ? 'Maintaining benefits' : ''}</div>
              <div>{strengthsCategories.indexOf('Managing health care needs') >= 0 ? 'Managing health care needs' : ''}</div>
              <div>{strengthsCategories.indexOf('Managing/using caregivers') >= 0 ? 'Managing/using caregivers' : ''}</div>
              <div>{strengthsCategories.indexOf('Meal preparation') >= 0 ? 'Meal preparation' : ''}</div>
              <div>{strengthsCategories.indexOf('Money management') >= 0 ? 'Money management' : ''}</div>
              <div>{strengthsCategories.indexOf('Motivated to obtain housing') >= 0 ? 'Motivated to obtain housing' : ''}</div>
              <div>{strengthsCategories.indexOf('Motivated to resolve legal/credit issues') >= 0 ? 'Motivated to resolve legal/credit issues' : ''}</div>

              <div>{strengthsCategories.indexOf('Paying bills') >= 0 ? 'Paying bills' : ''}</div>
              <div>{strengthsCategories.indexOf('Paying rent/utilities') >= 0 ? 'Paying rent/utilities' : ''}</div>
              <div>{strengthsCategories.indexOf('Shopping for food and necessities') >= 0 ? 'Shopping for food and necessities' : ''}</div>
              <div>{strengthsCategories.indexOf('Support from family/friends') >= 0 ? 'Support from family/friends' : ''}</div>
              <div>{strengthsCategories.indexOf('Taking medication') >= 0 ? 'Taking medication' : ''}</div>
              <div>{strengthsCategories.indexOf('Other') >= 0 ? 'Other' : ''}</div>
              <div>{otherStrengths}</div>
            </div>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font">
              <span style={{fontWeight: 'bold'}}>
                Housing goals
              </span>
            </Label>
          </Col>
        </Row>

        {housingGoalsSet && (
          <Row>
            <Col sm="4">
              <Label className="label-font" htmlFor="housingGoalsSetReview">
                <h5>
                  <b>
                    Have goals been set for this authorization period?
                  </b>
                </h5>
              </Label>
              <p className="label-font" name="housingGoalsSetReview">
                {housingGoalsSet}
              </p>
              {housingGoalsSet === 'Yes' && housingGoalsCount && (
                <>
                  <Label className="label-font">
                    <b>Number of goals:</b>
                  </Label>
                  <p className="label-font">
                    {housingGoalsCount}
                  </p>
                </>
              )}
              {housingGoalsSet === 'Yes' && housingGoalsConfidence && (
                <>
                  <Label className="label-font">
                    <b>Confidence level:</b>
                  </Label>
                  <p className="label-font">
                    {housingGoalsConfidence}
                  </p>
                </>
              )}
            </Col>
          </Row>
        )}

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font">
              <span style={{fontWeight: 'bold'}}>
                Housing preferences
              </span>
            </Label>
          </Col>
        </Row>

        {preferredHousingType && (
          <Row>
            <Col sm="4">
              <Label className="label-font" htmlFor="preferredHousingTypeReview">
                <h5>
                  <b>
                    What type of housing is preferred by the client?
                  </b>
                </h5>
              </Label>
              <p className="label-font" name="preferredHousingTypeReview">
                {preferredHousingType}
              </p>
              {preferredHousingType === 'Other' && preferredHousingTypeOther && (
                <p className="label-font">
                  {preferredHousingTypeOther}
                </p>
              )}
            </Col>
          </Row>
        )}

        <div className="spacer" />

        {preferredHousingLocation && (
          <Row>
            <Col sm="4">
              <Label className="label-font" htmlFor="preferredHousingLocationReview">
                <h5>
                  <b>
                    What type of housing location is preferred by the client?
                  </b>
                </h5>
              </Label>
              <p className="label-font" name="preferredHousingLocationReview">
                {preferredHousingLocation}
              </p>
            </Col>
          </Row>
        )}

        <div className="spacer" />
        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewClose">
              <h5>
                <b>
                  Close to
                </b>
              </h5>
            </Label>
            <div>{closeToCat.indexOf("Transportation") >= 0 ? "Transportation" : ''}</div>
            <div>{closeToCat.indexOf("Recreation/Cultural") >= 0 ? "Recreation/Cultural" : ''}</div>
            <div>{closeToCat.indexOf("Shopping") >= 0 ? "Shopping" : ''}</div>
            <div>{closeToCat.indexOf("Medical Services") >= 0 ? "Medical Services" : ''}</div>
            <div>{closeToCat.indexOf("Family/Friends") >= 0 ? "Family/Friends" : ''}</div>
            <div>{closeToCat.indexOf("Place of Worship") >= 0 ? "Place of Worship" : ''}</div>
            <div>{closeToCat.indexOf("Transportation") >= 0 ? "Other" : ''}</div>
            <div>{otherCloseTo}</div>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewLivingSpace">
              <h5>
                <b>
                  Living space
                </b>
              </h5>
            </Label>
            <div>{livingSpaceCat.indexOf("Studio") >= 0 ? "Studio" : ''}</div>
            <div>{livingSpaceCat.indexOf("1 Bedroom") >= 0 ? "1 Bedroom" : ''}</div>
            <div>{livingSpaceCat.indexOf("2 Bedroom") >= 0 ? "2 Bedroom" : ''}</div>
            <div>{livingSpaceCat.indexOf("Onsite Laundry") >= 0 ? "Onsite Laundry" : ''}</div>

            <div>{livingSpaceCat.indexOf("Nonsmoking") >= 0 ? "Nonsmoking" : ''}</div>
            <div>{livingSpaceCat.indexOf("Smoking Allowed") >= 0 ? "Smoking Allowed" : ''}</div>
            <div>{livingSpaceCat.indexOf("Pets Allowed") >= 0 ? "Pets Allowed" : ''}</div>
            <div>{livingSpaceCat.indexOf("Bottom Floor/Elevator") >= 0 ? "Bottom Floor/Elevator" : ''}</div>

            <div>{livingSpaceCat.indexOf("Accessible Unit") >= 0 ? "Accessible Unit" : ''}</div>
            <div>{livingSpaceCat.indexOf("Parking") >= 0 ? "Parking" : ''}</div>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="6">
            <Label className="label-font" htmlFor="housingReviewLivingSpaceDescription">
              <b>
                Please describe other relevant housing preferences:
                </b>
            </Label>
            <p className="label-font" name="housingReviewLivingSpaceDescription">
              {housingPreferenceDescription}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="10">
            <h3>
              Personal Information Related To Housing Assessment
            </h3>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewWheel">
              <h5>
                <b>
                  Does client use a wheelchair
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewWheel">
              {personalInformationObj.wheelChairRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewWidth">
              <h5>
                <b>
                  Width
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewWidth">
              {personalInformationObj.wheelWidth}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewMoE">
              <h5>
                <b>
                  Manual or Electric
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewMoE">
              {personalInformationObj.manualElectric}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewPet">
              <h5>
                <b>
                  Does the client have a pet
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewPet">
              {personalInformationObj.petRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewAnimal">
              <h5>
                <b>
                  Does the client have a service animal
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewAnimal">
              {personalInformationObj.serviceAnimalRadio}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewSmoke">
              <h5>
                <b>
                  Does the client smoke
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewSmoke">
              {personalInformationObj.smokeRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewMari">
              <h5>
                <b>
                  Does the client use medical marijuana
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewMari">
              {personalInformationObj.marijuanaRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewDischarge">
              <h5>
                <b>
                  Has the client served in the U.S. military with a qualified discharge?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewDischarge">
              {personalInformationObj.dischargeRadio}
            </p>
          </Col>
        </Row>
        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewArrested">
              <h5>
                <b>
                  Has the client ever been arrested?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewArrested">
              {personalInformationObj.arrestedRadio}
            </p>
          </Col>

          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewCharged">
              <h5>
                <b>
                  Client charged and convicted of a crime?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewCharged">
              {personalInformationObj.crimeRadio}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewOffender">
              <h5>
                <b>
                  Is the client a registered sex offender or been
                  convicted or manufacturing methamphetamines?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewOffender">
              {personalInformationObj.convictedRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewLiving">
              <h5>
                <b>
                  Will anyone else be living with the client?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewLiving">
              {personalInformationObj.livingWithClientRadio}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          {
            personalInformationObj.famPartFriend ?
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewFam">
                  <h5>
                    <b>
                      Family/partner/friend
                  </b>
                  </h5>
                </Label>
                <p className="label-font" name="housingReviewFam">
                  {personalInformationObj.famPartFriend}
                </p>
              </Col>
              :
              null
          }
          {
            personalInformationObj.aidField ?
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewAid">
                  <h5>
                    <b>
                      Live-in aid
                  </b>
                  </h5>
                </Label>
                <p className="label-font" name="housingReviewAid">
                  {personalInformationObj.aidField}
                </p>
              </Col>
              :
              null
          }
          {

            personalInformationObj.housingPreference ?
              <>
                <Col sm="4">
                  <Label className="label-font" htmlFor="housingReviewAid">
                    <h5>
                      <b>
                        Other Relevant Personal Information Related To Housing Placement
                    </b>
                    </h5>
                  </Label>
                  <p className="label-font" name="housingReviewAid">
                    {personalInformationObj.housingPreference}
                  </p>
                </Col>
              </>
              :
              null
          }
        </Row>
        <div className="spacer" />

        <h3 >
          Housing History
        </h3>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewRental">
              <h5>
                <b>
                  Does the client have any rental history?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewRental">
              {personalInformationObj.rentalRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewSubHousing">
              <h5>
                <b>
                  Has the client ever received subsidized housing from a public housing authority?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewSubHousing">
              {personalInformationObj.subsidizedHousingRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewPubHousing">
              <h5>
                <b>
                  Does the client owe anyone or any public housing authority past-due rent?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewPubHousing">
              {personalInformationObj.pastDueRadio}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewEvicted">
              <h5>
                <b>
                  Has the client ever been evicted from rental housing?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewEvicted">
              {personalInformationObj.evictedRentalRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewEvictedField">
              <h5>
                <b>
                  Evicted Dates
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewEvictedField">
              {personalInformationObj.evictedDatesField}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="10">
            <h3>
              Transportation information
            </h3>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewPubTransport">
              <h5>
                <b>
                  Does the client rely on public transportation?
                </b>
              </h5>
            </Label>
            <p className="label-font" htmlFor="housingReviewPubTransport">
              {publicTrasportationRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewVehicle">
              <h5>
                <b>
                  Does the client have a vehicle?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewVehicle">
              {vehicleRadio}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewClientTransport">
              <h5>
                <b>
                  Client's transportation needs
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewClientTransport">
              {transportationDescription}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <h3 >
          Housing options to review/explore
        </h3>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewIndiv">
              <h5>
                <b>
                  Are any of the options below available and appropriate for the individual?
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewIndiv">
              {individualHousingRadio}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <h3 >
          Tenant-based rental assistance
        </h3>

        <div className="spacer" />

        <div className="label-font">
          <div>{rentalAssistanceCat.indexOf("Housing choice") >= 0 ? "Housing choice" : ''}</div>
          <div>{rentalAssistanceCat.indexOf("Non-elderly disabled") >= 0 ? "Non-elderly disabled" : ''}</div>
          <div>{rentalAssistanceCat.indexOf("Veteran’s Assistance Supportive Housing") >= 0 ? "Veteran’s Assistance Supportive Housing" : ''}</div>

          <div>{rentalAssistanceCat.indexOf("Family Unification Program") >= 0 ? "Family Unification Program" : ''}</div>
          <div>{rentalAssistanceCat.indexOf("Housing Opportunities for Persons With AIDS (HOPWA)") >= 0 ? "Housing Opportunities for Persons With AIDS (HOPWA)" : ''}</div>
          <div>{rentalAssistanceCat.indexOf("Other") >= 0 ? "Other" : ''}</div>
          <div>{otherRentalAssistanceDetails}</div>
        </div>

        <div className="spacer" />

        <h3>
          Project-based rental subsidy
        </h3>

        <div className="spacer" />

        <div className="label-font">
          <div>{rentalSubsidyCategories.indexOf("HUD 811 (supportive housing for persons with disabilities)") >= 0 ? "HUD 811 (supportive housing for persons with disabilities)" : ''}</div>
          <div>{rentalSubsidyCategories.indexOf("HUD 202 (supportive housing for the elderly)") >= 0 ? "HUD 202 (supportive housing for the elderly)" : ''}</div>
          <div>{rentalSubsidyCategories.indexOf("Low-Income Housing Tax Credit") >= 0 ? "Low-Income Housing Tax Credit" : ''}</div>
          <div>{rentalSubsidyCategories.indexOf("Other") >= 0 ? "Other" : ''}</div>
          <div>{otherRentalSubsidyDetails}</div>
        </div>

        <div className="spacer" />

        <h3 >
          Continuum of care
        </h3>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewCoC">
              <h5>
                <b>
                  Continuum of Care
                </b>
              </h5>
            </Label>
            <div className="label-font" name="housingReviewCoC">
              <div>{continuumOfCareCat.indexOf("Shelter care") >= 0 ? "Shelter care" : ''}</div>
              <div>{continuumOfCareCat.indexOf("Homelessness Prevention and Rapid Re-Housing Program (HPRP)") >= 0 ? "Homelessness Prevention and Rapid Re-Housing Program (HPRP)" : ''}</div>
              <div>{continuumOfCareCat.indexOf("Permanent supportive housing") >= 0 ? "Permanent supportive housing" : ''}</div>
              <div>{continuumOfCareCat.indexOf("Transitional housing") >= 0 ? "Transitional housing" : ''}</div>
              <div>{continuumOfCareCat.indexOf("Other") >= 0 ? "Other" : ''}</div>
              <div>{otherContinuumOfCareDetails}</div>
            </div>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewDeptSub">
              <h5>
                <b>
                  Department of commerce subsidized
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewDeptSub">
              {deptOfCommerceSubsidized}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewHUD">
              <h5>
                <b>
                  Other HUD or USDA subsidy
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewHUD">
              {otherHUDOrUSDASubsidy}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewCounty">
              <h5>
                <b>
                  County/city program
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewCounty">
              {countyOrCityProgram}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="housingReviewOtherSect">
              <h5>
                <b>
                  Other
                </b>
              </h5>
            </Label>
            <p className="label-font" name="housingReviewOtherSect">
              {otherProgramsDetails}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <hr className="mtb-35" />

        {
          (memberInfo.isHomeless === 'Yes' && memberInfo.isEnrolleeEligibleForAHAH === 'Yes') && 
          (
            <>
            <Row>
              <Col sm='10'>
                <h2 className='poppinsH2'>
                  Apple Health and Homes Rental Assistance Program (AHAH-RAP)
                  Drawing Information
                </h2>
              </Col>
            </Row>

            <div className='spacer' />

            <Row>
              <Col sm="4">
                <Label className='label-font' htmlFor='reviewChronicHomeless'>
                  <b>
                    Does the enrollee meet the AHAH definition of 
                    chronically homeless?
                  </b>
                </Label>
                <p className='label-font' name="reviewChronicHomeless">
                  {ahahChronicRadio}
                  {
                    ahahChronicRadio === 'Yes' &&
                    (
                      <>
                        {`, ${ahahChronicFirstLast} meets the AHAH definition of chronically homeless`}
                      </>
                    )
                  }
                </p>
              </Col>
              <Col sm="4">
                <Label className='label-font' htmlFor='reviewFreqResStay'>
                  <b>
                    Does the enrollee have frequent residential care stays (two or more occurrences in the 
                    past 12 months)?
                  </b>
                </Label>
                <p className='label-font' name="reviewFreqResStay">
                  {ahahFreqResRadio}
                  {
                    ahahFreqResRadio === 'Yes' &&
                    (
                      <>
                        {`, ${ahahFreqResStayFirstLast} has experienced frequent 
                        residential care stays as defined above.`}
                      </>
                    )
                  }
                </p>
              </Col>
              <Col sm="4">
                <Label className='label-font' htmlFor='reviewLengthyInst'>
                  <b>
                    Does the enrollee have frequent or lengthy 
                    institutional contacts (two or more instances
                    in the past 12 months or 90 days or greater)?
                  </b>
                </Label>
                <p className='label-font' name='reviewLengthyInst'>
                  {ahahLengthyRadio}
                  {
                    ahahLengthyRadio === 'Yes' &&
                    (
                      <>
                        {`, ${ahahLengthyFirstLast} has experienced frequent 
                        or lengthy institutional contacts as defined above.`}
                      </>
                    )
                  }
                </p>
              </Col>
            </Row>

            <hr className='mtb-35' />
          </>
          )
        }

        <hr className="mtb-35" />

        <Row>
          <Col sm="10">
            <h2 className="poppinsH2">
              Signatures
            </h2>
          </Col>
        </Row>

        <div className="spacer" />

        <h5 className="poppinsH5">
          Assessment reporter
        </h5>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewReportLast">
              <b>
                Last Name
              </b>
            </Label>
            <p className="label-font" name="sigReviewReportLast">
              {assessmentReporter.reporterLast}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewReportFirst">
              <b>
                First Name
              </b>
            </Label>
            <p className="label-font" name="sigReviewReportFirst">
              {assessmentReporter.reporterFirst}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewPosCred">
              <b>
                Position/Credentials
              </b>
            </Label>
            <p className="label-font" name="sigReviewPosCred">
              {assessmentReporter.positionCred}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewProvLast">
              <b>
                Provider Agency Name
              </b>
            </Label>
            <p className="label-font" name="sigReviewProvLast">
              {provAgencyName}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewRepSig">
              <b>
                Signature
              </b>
            </Label>
            <p className="label-font" name="sigReviewRepSig">
              {assessmentReporter.signature}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" name="sigReviewRepDate">
              <b>
                Date
              </b>
            </Label>
            <p className="label-font" name="sigReviewRepDate">
              {assessmentReporter.reporterDate !== '' ? moment(assessmentReporter.reporterDate).format("MM/DD/YYYY") : ''}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewReportEmail">
              <b>
                Email Address
                </b>
            </Label>
            <p className="label-font" name="sigReviewReportEmail">
              {assessmentReporter.reporterEmail}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewReportPhone">
              <b>
                Phone Number
                </b>
            </Label>
            <p className="label-font" name="sigReviewReportPhone">
              {assessmentReporter.reporterPhone}
            </p>
          </Col>
        </Row>

        <div className='spacer' />

        {
          assessmentCategories.indexOf("FCS-AHAH_accurate_info") >= 0 && 
          <div className='label-font'>
            I, the FCS-SH Provider, worked with my potential enrollee to share accurate information to the best of my knowledge 
            for the purpose of connecting the potential enrollee to the FCS and AHAH Rental Assistance Program.
          </div>
        }

        <div className="spacer" />

        <h5 className="poppinsH5">
          Assessment supervisor
        </h5>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewSupLast">
              <b>
                Last Name
              </b>
            </Label>
            <p className="label-font" name="sigReviewSupLast">
              {assessmentSupervisor.supervisorLast}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewSupFirst">
              <b>
                First Name
              </b>
            </Label>
            <p className="label-font" name="sigReviewSupFirst">
              {assessmentSupervisor.supervisorFirst}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewSupPosCred">
              <b>
                Position/Credentials
              </b>
            </Label>
            <p className="label-font" name="sigReviewSupPosCred">
              {assessmentSupervisor.supervisorPosCred}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewSupSig">
              <b>
                Signature
              </b>
            </Label>
            <p className="label-font" name="sigReviewSupSig">
              {assessmentSupervisor.superSignature}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewSupDate">
              <b>
                Date
              </b>
            </Label>
            <p className="label-font" name="sigReviewSupDate">
              {assessmentSupervisor.supervisorDate !== '' ? moment(assessmentSupervisor.supervisorDate).format("MM/DD/YYYY") : ''}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <h5 className="poppinsH5">
          Enrollee information
        </h5>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" name="sigReviewEnrolleeLast">
              <b>
                Last Name
              </b>
            </Label>
            <p className="label-font" name="sigReviewEnrolleeLast">
              {enrolleeInformation.enrolleeLast}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" name="sigReviewEnrolleeFirst">
              <b>
                First Name
              </b>
            </Label>
            <p className="label-font" name="sigReviewEnrolleeFirst">
              {enrolleeInformation.enrolleeFirst}
            </p>
          </Col>
          <Col sm="4">
            <Label className="label-font" name="sigReviewEnrolleeDate">
              <b>
                Date
              </b>
            </Label>
            <p className="label-font" name="sigReviewEnrolleeDate">
              {enrolleeInformation.enrolleeDate !== '' ? moment(enrolleeInformation.enrolleeDate).format("MM/DD/YYYY") : ''}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" htmlFor="sigReviewEnrolleeTime">
              <b>
                Time Consent Received
              </b>
            </Label>
            <p className="label-font" name="sigReviewEnrolleeTime">
              {enrolleeInformation.time}
            </p>
          </Col>
          <Col sm="8">
            <Label className="label-font" name="sigReviewEnrolleeSig">
              <b>
                Signature
              </b>
            </Label>
            <p className="label-font" name="sigReviewEnrolleeSig">
              {enrolleeInformation.enrolleeSignature}
            </p>
          </Col>
        </Row>

        <div className="spacer" />

        {
          signatureCategories.indexOf('I, the potential enrollee, confirm that all answers have been provided to the best of my knowledge.') >= 0 && 
          <div className='label-font'>
            {signatureCategories[signatureCategories.indexOf('I, the potential enrollee, confirm that all answers have been provided to the best of my knowledge.')]}
          </div>
        }

        <div className='spacer' />

        {
          signatureCategories.indexOf("shared with the Department of Commerce, landlords, property managers, and/or their third-part administrator") >= 0 && 
          <div className='label-font'>
            I understand that if I am selected for AHAH-RAP the information on this assessment will be shared with the Department of Commerce, landlords, property managers,
            and/or their third-part administrator solely for the purposes of connecting me to housing that aligns with my preferences and for program
            monitoring and evaluation.
          </div>
        }
        
        <div className='spacer' />

        {signatureCategories.indexOf('Verbal consent was received from the potential enrollee.') >= 0 &&
          <div className="label-font">
            {signatureCategories[signatureCategories.indexOf('Verbal consent was received from the potential enrollee.')]}
          </div>
        }

        <div className="spacer" />

        <Row>
          <Col sm="4">
            <Label className="label-font" name="sigReviewEnrolleeNotes">
              <b>
                Notes
              </b>
            </Label>
            <p className="label-font" name="sigReviewEnrolleeNotes">
              {enrolleeInformation.enrolleeNotes}
            </p>
          </Col>
        </Row>

        <hr className='mtb-35' />

        <Row>
          <Col sm="10">
            <h2 className="poppinsH2">
              Documentation
            </h2>
          </Col>
        </Row>

        <div className='spacer' />

        <Label className='label-font' htmlFor='sigReviewDocuments'>
          <b>
            Documents
          </b>
        </Label>

        <div className='label-font' name='sigReviewDocuments'>
          {attachments.map(doc => (
            <>
              <div key={doc.documentName}>
                <span>
                  {doc.documentName}
                  &nbsp;-
                  <span>
                    {doc.fileName.slice(-3) === 'pdf' ?
                      <i className='icon icon-file-pdf' />
                      :
                      <i className='icon icon-file-image' />
                    }
                    {doc.fileName}
                  </span>
                </span>
              </div>
              <div className='spacer' />
            </>
          ))}
        </div>

        <div className="spacer" />

        <Label className="label-font" htmlFor="sigReviewDocuments">
          <b>
            Documentation Notes
          </b>
        </Label>
        <p className="label-font" name="sigReviewDocNotes">
          {documentNotes}
        </p>
      </div>
      <div className="pb-spacerRem-4" />
    </>
  );
}

@observer
class ReviewSubmit extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      redirect: false,
    };

    if(window.performance) {
			if(performance.navigation.type == 1) {
				window.location.href = '#';
			}
		}
  }

  componentWillMount () {

    if (housingstore.getSupportiveHousingRouteStatus('/documentation') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirect: true });
    } else if (
      housingstore.getSupportiveHousingRouteStatus('/reviewsubmit') !== 'completed' &&
      housingstore.getSupportiveHousingRouteStatus('/reviewsubmit') !== 'active'
    ) {
      housingstore.setSupportiveHousingPageStatus('#reviewsubmit', 'active');
      housingstore.setSupportiveHousingRouteStatus('/reviewsubmit', 'active');
    }
    
  }

  componentDidMount() {
    if (housingstore.confirmationId) {
      this.setState({
        redirect: true
      });
    }
    housingstore.setSignatures();
    window.onpopstate = () => {
      this.props.navigate(1);
    }
  }

  toggleModal = () => {
    const { navigate } = this.props;
    if (housingstore.errorCount > 0) {
      housingstore.setOpenModal();
    } else {
      housingstore.clearHousingAssessmentForm();
      housingstore.resetSupportiveHousingPage();
      housingstore.setOpenModal();
      navigate('/');
    }
  }

  goBack = () => {
    const { navigate } = this.props;
    housingstore.setSupportiveHousingPageStatus('#documentation', 'active');
    housingstore.setSupportiveHousingPageStatus('#reviewsubmit', 'disabled');
    housingstore.setSupportiveHousingRouteStatus('/documentation', 'active');
    housingstore.setSupportiveHousingRouteStatus('/reviewsubmit', 'inactive');
    navigate('/documentation');
  }

  handleSubmit() {
    // Re-Check - whether all the required date fields are entered by the Provider User
    if (!housingstore.memberInfo.memDOB || !housingstore.currentDate || !housingstore.memberInfo.dateAssessmentComp
      || !housingstore.assessmentReporter.reporterDate || !housingstore.enrolleeInformation.enrolleeDate) {
      housingstore.requiredDateValidationCheck = true;
      housingstore.incrementErrorCount();
      housingstore.setOpenModal();
    } else {
      housingstore.requiredDateValidationCheck = false;
      housingstore.turnOnBlocking();
      const props = this.props;
      const postUrl = '/SupportiveHousingAssessment/EN/api/v1/provconn/survey/tpa/submit';
      const data = housingstore.submitHousingAssessmentForm();

      axios({
        method: 'post',
        url: postUrl,
        data: data
      })
        .then(function (response) {
          housingstore.turnOffBlocking();
          if (response && response.status === 200) {
            housingstore.confirmationId = response.data.confirmationNbr;
            housingstore.submitSuccess = true;
            housingstore.setSupportiveHousingPageStatus('#reviewsubmit', 'active');
            housingstore.setSupportiveHousingRouteStatus('/reviewsubmit', 'completed');
            props.navigate('/confirmation');
          }
          if (response.data.confirmationID === null) {
            housingstore.incrementErrorCount();
            housingstore.setOpenModal();
          }
          return response;
        })
        .catch(function (error) {
          housingstore.incrementErrorCount();
          housingstore.turnOffBlocking();
          housingstore.setOpenModal();
          return error;
        });
    }
  }

  printPage = () => {
    const content = document.querySelector("#divcontents");
    const pri = document.querySelector("#ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }

  render() {

    const {
      openModal,
      errorCount,
      currentDate,
      memberInfo,
      healthNeedCat,
      riskFactorsCategories,
      instSettingsCategories,
      resCareFacilityCategories,
      institutionalSettingsRadio,
      multiResidentialCareRadio,
      multiInstSettingsRadio,
      multiInHomeCareRadio,
      additionalDetails,
      countDetails,
      strengthsCategories,
      otherStrengths,
      housingPreferenceCat,
      closeToCat,
      otherCloseTo,
      livingSpaceCat,
      housingPreferenceDescription,
      publicTrasportationRadio,
      vehicleRadio,
      transportationDescription,
      individualHousingRadio,
      rentalAssistanceCat,
      otherRentalAssistanceDetails,
      rentalSubsidyCategories,
      otherRentalSubsidyDetails,
      continuumOfCareCat,
      deptOfCommerceSubsidized,
      otherHUDOrUSDASubsidy,
      countyOrCityProgram,
      otherProgramsDetails,
      otherContinuumOfCareDetails,
      assessmentReporter,
      assessmentSupervisor,
      enrolleeInformation,
      totalIncome,
      housingType,
      isClientHoused,
      dateHoused,
      employmentCategories,
      incomeCategories,
      incomeOther,
      homelessRadio,
      homelessOther,
      currentHousingType,
      currentHousingTypeOther,
      housingAtRisk,
      housingAtRiskReasons,
      housingAtRiskOther,
      housingGoalsSet,
      housingGoalsCount,
      housingGoalsConfidence,
      preferredHousingType,
      preferredHousingTypeOther,
      preferredHousingLocation,
      personalInformationObj,
      ahahChronicHomelessness,
      ahahFreqResCareStay,
      ahahLengthyInstContacts,
      // documentCategories,
      documentNotes,
      // suppDocRadio,
      attachments,
      assessmentCategories,
      signatureCategories,
      supportiveHousingPagesAHAH, 
      supportiveHousingPagesNoAHAH,
    } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const {
      ahahChronicRadio,
      ahahChronicFirstLast,
    } = ahahChronicHomelessness;

    const {
      ahahFreqResRadio,
      ahahFreqResStayFirstLast
    } = ahahFreqResCareStay;

    const {
      ahahLengthyRadio,
      ahahLengthyFirstLast
    } = ahahLengthyInstContacts;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    const provAgencyName = housingstore.getProviderAgencyName(assessmentReporter);

    if (this.state.redirect) {
      housingstore.clearHousingAssessmentForm();
      housingstore.resetSupportiveHousingPage();
      return <Navigate to="/" />
    }

    return (
      <>
        {/* Error Popup */}
        <Modal className="errorModal" isOpen={openModal} toggle={this.toggleModal}>
          <ErrorPopup errorCount={errorCount} />
        </Modal>
        {/* Error Popup */}
        <span className="no-display">
          <PageForPrint />
        </span>
        <div className="border-form">
          <CustomProgressBar pages={supportiveHousingPages} />

          <div className='spacer-50' />

          <div>
            <Row>
              <Col sm="7">
                <h2 className="poppinsH2">
                  Review and Submit
              </h2>
              </Col>
            </Row>
            <div className="spacer-48" />
            <Row>
              <Col sm="10">
                <h5 className="poppinsH5">
                  Potential Enrollee Information
              </h5>
              </Col>
              <Col sm="2">
                <NavLink exact to="/" className='editBtn btn btn-link'>
                  Edit
              </NavLink>
              </Col>
            </Row>
            <div className="spacer" />

            {
              memberInfo.initReauth &&
              <div className="label-font">
                <i className="icon icon-ok" />
                {memberInfo.initReauth}
              </div>
            }

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewLast">
                  <b>Last Name</b>
                </Label>
                <p name="memReviewLast" className="label-font">
                  {memberInfo.memLast}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewMiddleInitial">
                  <b>Middle Initial</b>
                </Label>
                <p name="memReviewMiddleInitial" className="label-font">
                  {memberInfo.memMiddle }
                </p>
              </Col>               
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewFirst">
                  <b>First Name</b>
                </Label>
                <p name="memReviewFirst" className="label-font">
                  {memberInfo.memFirst}
                </p>
              </Col>
            </Row>

            <div className="spacer" />
            
            <Row>
              <Col sm="4">
                <Label className='label-font' htmlFor='memReviewPreferredName'>
                  <b>Preferred Name</b>
                </Label>
                <p name="memReviewPreferredName">
                  {memberInfo.memberPrefName}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewGender">
                  <b>Gender</b>
                </Label>
                <p name="memReviewGender" className="label-font">
                  {memberInfo.memGender}
                </p>
              </Col>               
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewDOB">
                  <b>Date of Birth</b>
                </Label>
                <p name="memReviewDOB" className="label-font">
                  {memberInfo.memDOB !== '' ? moment(memberInfo.memDOB).format("MM/DD/YYYY") : ''}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewDate">
                  <b>Date Received</b>
                </Label>
                <p name="memReviewDate" className="label-font">
                  {currentDate}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memAssessCompleted">
                  <b>Date Assessment Completed</b>
                </Label>
                <p name="memAssessCompleted" className="label-font">
                  {memberInfo.dateAssessmentComp !== '' ? moment(memberInfo.dateAssessmentComp).format("MM/DD/YYYY") : ''}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewAddr">
                  <b>Is experiencing homelessness?</b>
                </Label>
                <p name="memReviewAddr" className="label-font">
                  {memberInfo.isHomeless}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="12">
                <Label className="label-font" htmlFor="memReviewAddr">
                  <b>Would the potential enrollee like to be considered for the AHAH Rental Assistance Program (AHAH-RAP)?</b>
                </Label>
                <p name="memReviewAddr" className="label-font">
                  {memberInfo.isEnrolleeEligibleForAHAH}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="8">
                <Label className="label-font" htmlFor="memReviewAddr">
                  <b>Address</b>
                </Label>
                <p name="memReviewAddr" className="label-font">
                  {
                    `${memberInfo.memAddr ? `${memberInfo.memAddr}, ` : ''} ${memberInfo.memCity ? `${memberInfo.memCity}, ` : ''}  ${memberInfo.memCounty ? `${memberInfo.memCounty}, ` : ''} ${memberInfo.memState} ${memberInfo.memZip}`
                  }
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">              
                <Label className="label-font" htmlFor="memReviewEmail">
                  <b>Email</b>
                </Label>
                <p name="memReviewEmail" className="label-font">
                  {memberInfo.memEmail}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewProvOne">
                  <b>ProviderOne ID</b>
                </Label>
                <p name="memReviewProvOne" className="label-font">
                  {memberInfo.memProvOne}WA
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewPhone">
                  <b>Phone</b>
                </Label>
                <p name="memReviewPhone" className="label-font">
                  {memberInfo.memPhone}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewPhoneType">
                  <b>Phone Number Type</b>
                </Label>
                <p name="memReviewPhoneType" className="label-font">
                  {memberInfo.phoneType}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewNameOfContact">
                  <b>Name</b>
                </Label>
                <p name="memReviewNameOfContact" className="label-font">
                  {memberInfo.nameOfContact}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewTribe">
                  <b>Member of recognized tribe</b>
                </Label>
                <p name="memReviewTribe" className="label-font">
                  {memberInfo.memTribe}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewTribeDetails">
                  <b>Name of recognized tribe</b>
                </Label>
                <p name="memReviewTribeDetails" className="label-font">
                  {memberInfo.tribeDetails}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewVet">
                  <b>Veteran</b>
                </Label>
                <p name="memReviewVet" className="label-font">
                  {memberInfo.memVet}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="memReviewVetDetails">
                  <b>Military Branch</b>
                </Label>
                <p name="memReviewVetDetails" className="label-font">
                  {memberInfo.vetDetails}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <hr className="mtb-35" />

            <Row>
              <Col sm="10">
                <h2 className="poppinsH2">
                  Complex needs eligibility requirements
              </h2>
              </Col>
              <Col sm="2">
                <NavLink exact to="/healthneeds" className="editBtn btn btn-link">
                  Edit
              </NavLink>
              </Col>
            </Row>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Health needs
          </h5>

            <div className="spacer" />

            <div name="healthNeedsReview" className="label-font">
              {
                healthNeedCat.indexOf('opt1') >= 0 ?
                  `Mental health need where there is a need for improvement, stabilization or prevention of
              deterioration to functioning resulting from the presence of a mental illness (as determined 
                by a licensed behavioral health agency)`
                  :
                  null
              }
              <div className="spacer" />
              {
                healthNeedCat.indexOf('opt2') >= 0 ?
                  `Diagnosed with a substance use disorder (SUD), by meeting a one or higher level on the 
              American Society of Addiction Medicine (ASAM) Criteria (as determined by a licensed behavioral health agency)`
                  :
                  null
              }
              <div className="spacer" />
              {
                healthNeedCat.indexOf('opt3') >= 0 ?
                  `Needs assistance with three or more activities of daily living (ADL) or one or more hands-on ADL as determined
              by a Comprehensive Assessment and Reporting Evaluation (CARE)`
                  :
                  null
              }
              <div className="spacer" />
              {
                healthNeedCat.indexOf('opt4') >= 0 ?
                  `The client is a homeless individual with a disability, determined by a coordinated entry assessment. (Individual assessed to have a complex health need, which is defined as
                as a long continuing or indefinite physical condition requiring improvement, stablilization or prevention of deterioration of functioning [including ability to live independently without support])`
                  :
                  null
              }
            </div>

            <div className="spacer" />

            <Row>
              <Col sm="10">
                <h5 className="poppinsH5">
                  Risk factors
              </h5>
              </Col>
              <Col sm="2">
                <NavLink exact to="/riskfactors" className="editBtn btn btn-link">
                  Edit
              </NavLink>
              </Col>
            </Row>
            {
              riskFactorsCategories.indexOf('Chronically Homeless') >= 0 ?
                <>
                  <p className="label-font">
                    {
                      `Chronically homeless: an individual with a disabling condition who has been homeless for 
                  a period of at least one year, or an individual with a disabling condition who has had at least
                  four episodes of homelessness, as long as the combined occasions equal at least 12 months.`
                    }
                  </p>
                  <div className="spacer" />
                </>
                :
                null
            }
            {
              riskFactorsCategories.indexOf('Institutional Contacts') >= 0 ?
                <>
                  <p className="label-font">
                    {
                      `Frequent or lengthy institutional contacts (frequent, as in two or more instances in the 
                  past 12 months, or lengthy, as in lasting 90 days or more)`
                    }
                  </p>
                  <div className="spacer" />
                  <Row>
                    <Col sm="4">
                      <Label className="label-font" htmlFor="riskReviewInstSettings">
                        <b>
                          Is the client transitioning out of an institutional setting?
                    </b>
                      </Label>
                      <p name="riskReviewInstSettings" className="label-font">
                        {institutionalSettingsRadio}
                      </p>
                    </Col>
                    <Col sm="4">
                      <Label className="label-font" htmlFor="riskReviewSettings">
                        <b>
                          Institutional setting(s)
                    </b>
                      </Label>
                      <div name="riskReviewSettings" className="d-flex flex-column label-font">
                        <div>{instSettingsCategories.indexOf('Nursing') >= 0 ? 'Nursing' : ''}</div>
                        <div>{instSettingsCategories.indexOf('Inpatient psychiatric hospital') >= 0 ? 'Inpatient psychiatric hospital' : ''}</div>
                        <div>{instSettingsCategories.indexOf('Inpatient medical hospital') >= 0 ? 'Inpatient medical hospital' : ''}</div>
                        <div>{instSettingsCategories.indexOf('Correctional program or institution') >= 0 ? 'Correctional program or institution' : ''}</div>
                        <div>{instSettingsCategories.indexOf('Foster care facility or other youth facility') >= 0 ? 'Foster care facility or other youth facility' : ''}</div>
                      </div>
                    </Col>
                    <Col sm="4">
                      <Label className="label-font" htmlFor="riskReviewContacts">
                        <b>
                          Has the client resided within one of the previously listed institutional settings multiple times in the past year?
                    </b>
                      </Label>
                      <p name="riskReviewContacts" className="label-font">
                        {multiInstSettingsRadio}
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    {
                      multiInstSettingsRadio === "Yes" ?
                        <Col sm="4">
                          <Label className="label-font" htmlFor="riskReviewTimes">
                            <b>
                              Number of times
                      </b>
                          </Label>
                          <p name="riskReviewTimes" className="label-font">
                            {countDetails}
                          </p>
                        </Col>
                        :
                        null
                    }
                  </Row>
                  <div className="spacer" />
                </>
                :
                null
            }
            {
              riskFactorsCategories.indexOf('Residential Care') >= 0 ?
                <>
                  <p className="label-font">
                    {
                      `Frequent residential care stays (two or more occurrences in the past 12 months)`
                    }
                  </p>
                  <div className="spacer" />
                  <Row>
                    <Col sm="4">
                      <Label className="label-font" htmlFor="riskReviewResStay">
                        <b>
                          Has the client resided within a residential care facility two or more times in the past 12 months?
                    </b>
                      </Label>
                      <p name="riskReviewResStay" className="label-font">
                        {multiResidentialCareRadio}
                      </p>
                      <div name="riskReviewResStay" className="label-font">
                        {
                          multiResidentialCareRadio === 'Yes' ?
                            <div className="d-flex flex-column label-font">
                              <div>{resCareFacilityCategories.indexOf('Evaluation and treatment facility') >= 0 ? 'Evaluation and treatment facility' : ''}</div>
                              <div>{resCareFacilityCategories.indexOf('Detox center') >= 0 ? 'Detox center' : ''}</div>
                              <div>{resCareFacilityCategories.indexOf('Inpatient substance use treatment facility') >= 0 ? 'Inpatient substance use treatment facility' : ''}</div>
                              <div>{resCareFacilityCategories.indexOf('Adult residential care, assisted living or adult family home (AFH)') >= 0 ? 'Adult residential care, assisted living or adult family home (AFH)' : ''}</div>
                            </div>
                            :
                            null
                        }
                      </div>
                    </Col>
                  </Row>
                  <div className="spacer" />
                </>
                :
                null
            }
            {
              riskFactorsCategories.indexOf('In Home Care') >= 0 ?
                <>
                  <p className="label-font">
                    {`Frequent turnover of in-home caregivers (three or more occurrences in the past 12 months)`}
                  </p>
                  <div className="spacer" />
                  <Row>
                    <Col sm="4">
                      <Label className="label-font" htmlFor="riskReviewTurnover">
                        <b>
                          Within the last 12 months, has the client used three (or more) different in-home caregiver providers (Please provide supporting documentation with the assessment)?
                    </b>
                      </Label>
                      <p name="riskReviewTurnover" className="label-font">
                        {multiInHomeCareRadio}
                      </p>
                    </Col>
                  </Row>
                  <div className="spacer" />
                </>
                :
                null
            }
            {
              riskFactorsCategories.indexOf('Prism Score') >= 0 ?
                <>
                  <p className="label-font">
                    PRISM score (1.5 or above) (Contact the TPA, MCO, BHO, Health Home or HCS case manager to obtain the PRISM risk score)
              </p>
                  <div className="spacer" />
                </>
                :
                null
            }
            <Row>
              <Col sm="6">
                <Label className="label-font" htmlFor="riskReviewAdditional">
                  <b>
                    Additional details on risk factors
                </b>
                </Label>
                <p className="label-font" name="riskReviewAdditional">
                  {additionalDetails}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <hr className="mtb-35" />

            <Row>
              <Col sm="10">
                <h2 className="poppinsH2">
                  Housing assessment
              </h2>
              </Col>
              <Col sm="2">
                <NavLink exact to="/housingassessment" className="editBtn btn btn-link">
                  Edit
              </NavLink>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewEmpStat">
                  <b>
                    Employment status
                </b>
                </Label>
                <div className="d-flex flex-column label-font">
                  <div>{employmentCategories.indexOf('Unemployed') >= 0 ? 'Unemployed' : ''}</div>
                  <div>{employmentCategories.indexOf('Employed part time') >= 0 ? 'Employed part time' : ''}</div>
                  <div>{employmentCategories.indexOf('Employed full time') >= 0 ? 'Employed full time' : ''}</div>
                  <div>{employmentCategories.indexOf('Nonpaid employment activities') >= 0 ? 'Nonpaid employment activities' : ''}</div>
                  <div>{employmentCategories.indexOf('Enrolled in training/education program') >= 0 ? 'Enrolled in training/education program' : ''}</div>
                </div>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewIncome">
                  <b>
                    Income source
                </b>
                </Label>
                <div className="d-flex flex-column label-font">
                  <div>{incomeCategories.indexOf('Social Security (SSA)') >= 0 ? 'Social Security (SSA)' : ''}</div>
                  <div>{incomeCategories.indexOf('Pension') >= 0 ? 'Pension' : ''}</div>
                  <div>{incomeCategories.indexOf('Supplemental Security Income (SSI)') >= 0 ? 'Supplemental Security Income (SSI)' : ''}</div>
                  <div>{incomeCategories.indexOf('Social Security Disability Insurance (SSDI)') >= 0 ? 'Social Security Disability Insurance (SSDI)' : ''}</div>
                  <div>{incomeCategories.indexOf('Temporary Assistance for Needy Families (TANF)') >= 0 ? 'Temporary Assistance for Needy Families (TANF)' : ''}</div>
                  <div>{incomeCategories.indexOf('Housing and Essential Needs (HEN)') >= 0 ? 'Housing and Essential Needs (HEN)' : ''}</div>
                  <div>{incomeCategories.indexOf('Aged, Blind, or Disabled (ABD)') >= 0 ? 'Aged, Blind, or Disabled (ABD)' : ''}</div>
                  <div>{incomeCategories.indexOf('Employment') >= 0 ? 'Employment' : ''}</div>
                  <div>{incomeCategories.indexOf('None') >= 0 ? 'None' : ''}</div>
                  <div>{incomeCategories.indexOf('Other') >= 0 ? 'Other' : ''}</div>
                  <div>{incomeOther}</div>
                </div>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewTotIncome">
                  <b>
                    Total Income
                </b>
                </Label>
                <p className="label-font" name="housingReviewTotIncome">
                  {totalIncome}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewHousingType">
                  <b>
                    Housing
                </b>
                </Label>
                <p className="label-font" name="housingReviewHousingType">
                  {housingType}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewIsClientHoused">
                  <b>
                    Is the client housed?
                  </b>
                </Label>
                <p className="label-font" name="housingReviewIsClientHoused">
                  {isClientHoused}
                </p>
              </Col>
              {isClientHoused === 'Yes' && dateHoused && (
                <Col sm="4">
                  <Label className="label-font" htmlFor="housingReviewDateHoused">
                    <b>
                      What date did they get housed?
                    </b>
                  </Label>
                  <p className="label-font" name="housingReviewDateHoused">
                    {moment(dateHoused).format("MM/DD/YYYY")}
                  </p>
                </Col>
              )}
            </Row>

            {/* AC1: Current Housing Type */}
            {isClientHoused === 'Yes' && currentHousingType && (
              <>
                <div className="spacer" />
                <Row>
                  <Col sm="4">
                    <Label className="label-font" htmlFor="currentHousingTypeReview">
                      <b>
                        What type of housing does the client currently live in?
                      </b>
                    </Label>
                    <p className="label-font" name="currentHousingTypeReview">
                      {currentHousingType}
                    </p>
                    {currentHousingType === 'Other' && currentHousingTypeOther && (
                      <p className="label-font">
                        {currentHousingTypeOther}
                      </p>
                    )}
                  </Col>
                </Row>
              </>
            )}

            {/* AC2: Housing At Risk */}
            {isClientHoused === 'Yes' && housingAtRisk && (
              <>
                <div className="spacer" />
                <Row>
                  <Col sm="4">
                    <Label className="label-font" htmlFor="housingAtRiskReview">
                      <b>
                        Is the client's current housing at risk?
                      </b>
                    </Label>
                    <p className="label-font" name="housingAtRiskReview">
                      {housingAtRisk}
                    </p>
                  </Col>
                </Row>
                {housingAtRisk === 'Yes' && housingAtRiskReasons && housingAtRiskReasons.length > 0 && (
                  <Row>
                    <Col sm="4">
                      <Label className="label-font">
                        <b>Reasons:</b>
                      </Label>
                      <div className="d-flex flex-column label-font">
                        {housingAtRiskReasons.filter(reason => reason !== 'Other').map((reason, index) => (
                          <div key={index}>{reason}</div>
                        ))}
                        {housingAtRiskReasons.indexOf('Other') >= 0 && (
                          <div>Other</div>
                        )}
                        {housingAtRiskReasons.indexOf('Other') >= 0 && housingAtRiskOther && (
                          <div>{housingAtRiskOther}</div>
                        )}
                      </div>
                    </Col>
                  </Row>
                )}
              </>
            )}

            <div className="spacer" />

            {
              homelessRadio ?
                <>
                  <Label className="label-font" htmlFor="homelessOption">
                    <b>
                      Homeless Option
                </b>
                  </Label>
                  <p className="label-font" name="homelessOption">
                    {homelessRadio}
                  </p>
                  <p className="label-font" name="homelessOption">
                    {homelessOther}
                  </p>

                  <div className="spacer" />
                </>
                :
                null
            }


            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewStrengths">
                  <b>
                    Strengths
                </b>
                </Label>
                <div className="d-flex flex-column label-font">
                  <div>{strengthsCategories.indexOf('Arranging apartment repairs') >= 0 ? 'Arranging apartment repairs' : ''}</div>
                  <div>{strengthsCategories.indexOf('Desire to work or engage in community activities') >= 0 ? 'Desire to work or engage in community activities' : ''}</div>
                  <div>{strengthsCategories.indexOf('Driving/using public transportation') >= 0 ? 'Driving/using public transportation' : ''}</div>
                  <div>{strengthsCategories.indexOf('Filling prescriptions') >= 0 ? 'Filling prescriptions' : ''}</div>
                  <div>{strengthsCategories.indexOf('Getting along with neighbors, landlords, etc.') >= 0 ? 'Getting along with neighbors, landlords, etc.' : ''}</div>
                  <div>{strengthsCategories.indexOf('Housekeeping') >= 0 ? 'Housekeeping' : ''}</div>
                  <div>{strengthsCategories.indexOf('Hygiene') >= 0 ? 'Hygiene' : ''}</div>
                  <div>{strengthsCategories.indexOf('Lease compliance') >= 0 ? 'Lease compliance' : ''}</div>

                  <div>{strengthsCategories.indexOf('Long-term rental history') >= 0 ? 'Long-term rental history' : ''}</div>
                  <div>{strengthsCategories.indexOf('Maintaining benefits') >= 0 ? 'Maintaining benefits' : ''}</div>
                  <div>{strengthsCategories.indexOf('Managing health care needs') >= 0 ? 'Managing health care needs' : ''}</div>
                  <div>{strengthsCategories.indexOf('Managing/using caregivers') >= 0 ? 'Managing/using caregivers' : ''}</div>
                  <div>{strengthsCategories.indexOf('Meal preparation') >= 0 ? 'Meal preparation' : ''}</div>
                  <div>{strengthsCategories.indexOf('Money management') >= 0 ? 'Money management' : ''}</div>
                  <div>{strengthsCategories.indexOf('Motivated to obtain housing') >= 0 ? 'Motivated to obtain housing' : ''}</div>
                  <div>{strengthsCategories.indexOf('Motivated to resolve legal/credit issues') >= 0 ? 'Motivated to resolve legal/credit issues' : ''}</div>

                  <div>{strengthsCategories.indexOf('Paying bills') >= 0 ? 'Paying bills' : ''}</div>
                  <div>{strengthsCategories.indexOf('Paying rent/utilities') >= 0 ? 'Paying rent/utilities' : ''}</div>
                  <div>{strengthsCategories.indexOf('Shopping for food and necessities') >= 0 ? 'Shopping for food and necessities' : ''}</div>
                  <div>{strengthsCategories.indexOf('Support from family/friends') >= 0 ? 'Support from family/friends' : ''}</div>
                  <div>{strengthsCategories.indexOf('Taking medication') >= 0 ? 'Taking medication' : ''}</div>
                  <div>{strengthsCategories.indexOf('Other') >= 0 ? 'Other' : ''}</div>
                  <div>{otherStrengths}</div>
                </div>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font">
                  <span style={{fontWeight: 'bold'}}>
                    Housing goals
                  </span>
                </Label>
              </Col>
            </Row>

            {housingGoalsSet && (
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="housingGoalsSetReview">
                    <b>
                      Have goals been set for this authorization period?
                    </b>
                  </Label>
                  <p className="label-font" name="housingGoalsSetReview">
                    {housingGoalsSet}
                  </p>
                  {housingGoalsSet === 'Yes' && housingGoalsCount && (
                    <>
                      <Label className="label-font">
                        <b>Number of goals:</b>
                      </Label>
                      <p className="label-font">
                        {housingGoalsCount}
                      </p>
                    </>
                  )}
                  {housingGoalsSet === 'Yes' && housingGoalsConfidence && (
                    <>
                      <Label className="label-font">
                        <b>Confidence level:</b>
                      </Label>
                      <p className="label-font">
                        {housingGoalsConfidence}
                      </p>
                    </>
                  )}
                </Col>
              </Row>
            )}

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font">
                  <span style={{fontWeight: 'bold'}}>
                    Housing preferences
                  </span>
                </Label>
              </Col>
            </Row>

            {preferredHousingType && (
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="preferredHousingTypeReview">
                    <b>
                      What type of housing is preferred by the client?
                    </b>
                  </Label>
                  <p className="label-font" name="preferredHousingTypeReview">
                    {preferredHousingType}
                  </p>
                  {preferredHousingType === 'Other' && preferredHousingTypeOther && (
                    <p className="label-font">
                      {preferredHousingTypeOther}
                    </p>
                  )}
                </Col>
              </Row>
            )}

            <div className="spacer" />

            {preferredHousingLocation && (
              <Row>
                <Col sm="4">
                  <Label className="label-font" htmlFor="preferredHousingLocationReview">
                    <b>
                      What type of housing location is preferred by the client?
                    </b>
                  </Label>
                  <p className="label-font" name="preferredHousingLocationReview">
                    {preferredHousingLocation}
                  </p>
                </Col>
              </Row>
            )}

            <div className="spacer" />
            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewClose">
                  <b>
                    Close to
                </b>
                </Label>
                <div>{closeToCat.indexOf("Transportation") >= 0 ? "Transportation" : ''}</div>
                <div>{closeToCat.indexOf("Recreation/Cultural") >= 0 ? "Recreation/Cultural" : ''}</div>
                <div>{closeToCat.indexOf("Shopping") >= 0 ? "Shopping" : ''}</div>
                <div>{closeToCat.indexOf("Medical Services") >= 0 ? "Medical Services" : ''}</div>
                <div>{closeToCat.indexOf("Family/Friends") >= 0 ? "Family/Friends" : ''}</div>
                <div>{closeToCat.indexOf("Place of Worship") >= 0 ? "Place of Worship" : ''}</div>
                <div>{closeToCat.indexOf("Transportation") >= 0 ? "Other" : ''}</div>
                <div>{otherCloseTo}</div>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewLivingSpace">
                  <b>
                    Living space
                </b>
                </Label>
                <div>{livingSpaceCat.indexOf("Studio") >= 0 ? "Studio" : ''}</div>
                <div>{livingSpaceCat.indexOf("1 Bedroom") >= 0 ? "1 Bedroom" : ''}</div>
                <div>{livingSpaceCat.indexOf("2 Bedroom") >= 0 ? "2 Bedroom" : ''}</div>
                <div>{livingSpaceCat.indexOf("Onsite Laundry") >= 0 ? "Onsite Laundry" : ''}</div>

                <div>{livingSpaceCat.indexOf("Nonsmoking") >= 0 ? "Nonsmoking" : ''}</div>
                <div>{livingSpaceCat.indexOf("Smoking Allowed") >= 0 ? "Smoking Allowed" : ''}</div>
                <div>{livingSpaceCat.indexOf("Pets Allowed") >= 0 ? "Pets Allowed" : ''}</div>
                <div>{livingSpaceCat.indexOf("Bottom Floor/Elevator") >= 0 ? "Bottom Floor/Elevator" : ''}</div>

                <div>{livingSpaceCat.indexOf("Accessible Unit") >= 0 ? "Accessible Unit" : ''}</div>
                <div>{livingSpaceCat.indexOf("Parking") >= 0 ? "Parking" : ''}</div>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="6">
                <Label className="label-font" htmlFor="housingReviewLivingSpaceDescription">
                  <b>
                    Please describe other relevant housing preferences:
                </b>
                </Label>
                <p className="label-font" name="housingReviewLivingSpaceDescription">
                  {housingPreferenceDescription}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="10">
                <h5 className="poppinsH5">
                  Personal Information Related To Housing Assessment
              </h5>
              </Col>
              <Col sm="2">
                <NavLink exact to="/personalhousinghist" className="editBtn btn btn-link">
                  Edit
              </NavLink>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewWheel">
                  <b>
                    Does client use a wheelchair
                </b>
                </Label>
                <p className="label-font" name="housingReviewWheel">
                  {personalInformationObj.wheelChairRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewWidth">
                  <b>
                    Width
                </b>
                </Label>
                <p className="label-font" name="housingReviewWidth">
                  {personalInformationObj.wheelWidth}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewMoE">
                  <b>
                    Manual or Electric
                </b>
                </Label>
                <p className="label-font" name="housingReviewMoE">
                  {personalInformationObj.manualElectric}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewPet">
                  <b>
                    Does the client have a pet
                </b>
                </Label>
                <p className="label-font" name="housingReviewPet">
                  {personalInformationObj.petRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewAnimal">
                  <b>
                    Does the client have a service animal
                </b>
                </Label>
                <p className="label-font" name="housingReviewAnimal">
                  {personalInformationObj.serviceAnimalRadio}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewSmoke">
                  <b>
                    Does the client smoke
                </b>
                </Label>
                <p className="label-font" name="housingReviewSmoke">
                  {personalInformationObj.smokeRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewMari">
                  <b>
                    Does the client use medical marijuana
                </b>
                </Label>
                <p className="label-font" name="housingReviewMari">
                  {personalInformationObj.marijuanaRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewDischarge">
                  <b>
                    Has the client served in the U.S. military with a qualified discharge?
                </b>
                </Label>
                <p className="label-font" name="housingReviewDischarge">
                  {personalInformationObj.dischargeRadio}
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewArrested">
                  <b>
                    Has the client ever been arrested?
                </b>
                </Label>
                <p className="label-font" name="housingReviewArrested">
                  {personalInformationObj.arrestedRadio}
                </p>
              </Col>

              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewCharged">
                  <b>
                    Client charged and convicted of a crime?
                </b>
                </Label>
                <p className="label-font" name="housingReviewCharged">
                  {personalInformationObj.crimeRadio}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewOffender">
                  <b>
                    Is the client a registered sex offender or been
                    convicted or manufacturing methamphetamines?
                </b>
                </Label>
                <p className="label-font" name="housingReviewOffender">
                  {personalInformationObj.convictedRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewLiving">
                  <b>
                    Will anyone else be living with the client?
                </b>
                </Label>
                <p className="label-font" name="housingReviewLiving">
                  {personalInformationObj.livingWithClientRadio}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              {
                personalInformationObj.famPartFriend ?
                  <Col sm="4">
                    <Label className="label-font" htmlFor="housingReviewFam">
                      <b>
                        Family/partner/friend
                  </b>
                    </Label>
                    <p className="label-font" name="housingReviewFam">
                      {personalInformationObj.famPartFriend}
                    </p>
                  </Col>
                  :
                  null
              }
              {
                personalInformationObj.aidField ?
                  <Col sm="4">
                    <Label className="label-font" htmlFor="housingReviewAid">
                      <b>
                        Live-in aid
                  </b>
                    </Label>
                    <p className="label-font" name="housingReviewAid">
                      {personalInformationObj.aidField}
                    </p>
                  </Col>
                  :
                  null
              }
              {

                personalInformationObj.housingPreference ?
                  <>
                    <Col sm="4">
                      <Label className="label-font" htmlFor="housingReviewAid">
                        <b>
                          Other Relevant Personal Information Related To Housing Placement
                    </b>
                      </Label>
                      <p className="label-font" name="housingReviewAid">
                        {personalInformationObj.housingPreference}
                      </p>
                    </Col>
                  </>
                  :
                  null
              }
            </Row>
            <div className="spacer" />

            <h5 className="poppinsH5">
              Housing History
          </h5>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewRental">
                  <b>
                    Does the client have any rental history?
                </b>
                </Label>
                <p className="label-font" name="housingReviewRental">
                  {personalInformationObj.rentalRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewSubHousing">
                  <b>
                    Has the client ever received subsidized housing from a public housing authority?
                </b>
                </Label>
                <p className="label-font" name="housingReviewSubHousing">
                  {personalInformationObj.subsidizedHousingRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewPubHousing">
                  <b>
                    Does the client owe anyone or any public housing authority past-due rent?
                </b>
                </Label>
                <p className="label-font" name="housingReviewPubHousing">
                  {personalInformationObj.pastDueRadio}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewEvicted">
                  <b>
                    Has the client ever been evicted from rental housing?
                </b>
                </Label>
                <p className="label-font" name="housingReviewEvicted">
                  {personalInformationObj.evictedRentalRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewEvictedField">
                  <b>
                    Evicted Dates
                </b>
                </Label>
                <p className="label-font" name="housingReviewEvictedField">
                  {personalInformationObj.evictedDatesField}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="10">
                <h5 className="poppinsH5">
                  Transportation information
              </h5>
              </Col>
              <Col sm="2">
                <NavLink exact to="/transportationinformation" className="editBtn btn btn-link">
                  Edit
              </NavLink>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewPubTransport">
                  <b>
                    Does the client rely on public transportation?
                </b>
                </Label>
                <p className="label-font" htmlFor="housingReviewPubTransport">
                  {publicTrasportationRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewVehicle">
                  <b>
                    Does the client have a vehicle?
                </b>
                </Label>
                <p className="label-font" name="housingReviewVehicle">
                  {vehicleRadio}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewClientTransport">
                  <b>
                    Client's transportation needs
                </b>
                </Label>
                <p className="label-font" name="housingReviewClientTransport">
                  {transportationDescription}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Housing options to review/explore
          </h5>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewIndiv">
                  <b>
                    Are any of the options below available and appropriate for the individual?
                </b>
                </Label>
                <p className="label-font" name="housingReviewIndiv">
                  {individualHousingRadio}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Tenant-based rental assistance
          </h5>

            <div className="spacer" />

            <div className="label-font">
              <div>{rentalAssistanceCat.indexOf("Housing choice") >= 0 ? "Housing choice" : ''}</div>
              <div>{rentalAssistanceCat.indexOf("Non-elderly disabled") >= 0 ? "Non-elderly disabled" : ''}</div>
              <div>{rentalAssistanceCat.indexOf("Veteran’s Assistance Supportive Housing") >= 0 ? "Veteran’s Assistance Supportive Housing" : ''}</div>

              <div>{rentalAssistanceCat.indexOf("Family Unification Program") >= 0 ? "Family Unification Program" : ''}</div>
              <div>{rentalAssistanceCat.indexOf("Housing Opportunities for Persons With AIDS (HOPWA)") >= 0 ? "Housing Opportunities for Persons With AIDS (HOPWA)" : ''}</div>
              <div>{rentalAssistanceCat.indexOf("Other") >= 0 ? "Other" : ''}</div>
              <div>{otherRentalAssistanceDetails}</div>
            </div>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Project-based rental subsidy
          </h5>

            <div className="spacer" />

            <div className="label-font">
              <div>{rentalSubsidyCategories.indexOf("HUD 811 (supportive housing for persons with disabilities)") >= 0 ? "HUD 811 (supportive housing for persons with disabilities)" : ''}</div>
              <div>{rentalSubsidyCategories.indexOf("HUD 202 (supportive housing for the elderly)") >= 0 ? "HUD 202 (supportive housing for the elderly)" : ''}</div>
              <div>{rentalSubsidyCategories.indexOf("Low-Income Housing Tax Credit") >= 0 ? "Low-Income Housing Tax Credit" : ''}</div>
              <div>{rentalSubsidyCategories.indexOf("Other") >= 0 ? "Other" : ''}</div>
              <div>{otherRentalSubsidyDetails}</div>
            </div>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Continuum of care
          </h5>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewCoC">
                  <b>
                    Continuum of Care
                </b>
                </Label>
                <div className="label-font" name="housingReviewCoC">
                  <div>{continuumOfCareCat.indexOf("Shelter care") >= 0 ? "Shelter care" : ''}</div>
                  <div>{continuumOfCareCat.indexOf("Homelessness Prevention and Rapid Re-Housing Program (HPRP)") >= 0 ? "Homelessness Prevention and Rapid Re-Housing Program (HPRP)" : ''}</div>
                  <div>{continuumOfCareCat.indexOf("Permanent supportive housing") >= 0 ? "Permanent supportive housing" : ''}</div>
                  <div>{continuumOfCareCat.indexOf("Transitional housing") >= 0 ? "Transitional housing" : ''}</div>
                  <div>{continuumOfCareCat.indexOf("Other") >= 0 ? "Other" : ''}</div>
                  <div>{otherContinuumOfCareDetails}</div>
                </div>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewDeptSub">
                  <b>
                    Department of commerce subsidized
                </b>
                </Label>
                <p className="label-font" name="housingReviewDeptSub">
                  {deptOfCommerceSubsidized}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewHUD">
                  <b>
                    Other HUD or USDA subsidy
                </b>
                </Label>
                <p className="label-font" name="housingReviewHUD">
                  {otherHUDOrUSDASubsidy}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewCounty">
                  <b>
                    County/city program
                </b>
                </Label>
                <p className="label-font" name="housingReviewCounty">
                  {countyOrCityProgram}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="housingReviewOther">
                  <b>
                    Other
                </b>
                </Label>
                <p className="label-font" name="housingReviewOther">
                  {otherProgramsDetails}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <hr className="mtb-35" />

            {
              (isHomeless === 'Yes'  && isEnrolleeEligibleForAHAH === 'Yes') && 
              (
                <>
                  <Row>
                    <Col sm='10'>
                      <h2 className='poppinsH2'>
                        Apple Health and Homes Rental Assistance Program (AHAH-RAP)
                        Drawing Information
                      </h2>
                    </Col>
                    <Col sm="2">
                      <NavLink exact to="/ahah-rap" className="editBtn btn btn-link">
                        Edit
                      </NavLink>
                    </Col>
                  </Row>

                  <div className='spacer' />

                  <Row>
                    <Col sm="4">
                      <Label className='label-font' htmlFor='reviewChronicHomeless'>
                        <b>
                          Does the enrollee meet the AHAH definition of 
                          chronically homeless?
                        </b>
                      </Label>
                      <p className='label-font' name="reviewChronicHomeless">
                        {ahahChronicRadio}
                        {
                          ahahChronicRadio === 'Yes' &&
                          (
                            <>
                              {`, ${ahahChronicFirstLast} meets the AHAH definition of chronically homeless`}
                            </>
                          )
                        }
                      </p>
                    </Col>
                    <Col sm="4">
                      <Label className='label-font' htmlFor='reviewFreqResStay'>
                        <b>
                          Does the enrollee have frequent residential care stays (two or more occurrences in the 
                          past 12 months)?
                        </b>
                      </Label>
                      <p className='label-font' name="reviewFreqResStay">
                        {ahahFreqResRadio}
                        {
                          ahahFreqResRadio === 'Yes' &&
                          (
                            <>
                              {`, ${ahahFreqResStayFirstLast} has experienced frequent 
                              residential care stays as defined above.`}
                            </>
                          )
                        }
                      </p>
                    </Col>
                    <Col sm="4">
                      <Label className='label-font' htmlFor='reviewLengthyInst'>
                        <b>
                          Does the enrollee have frequent or lengthy 
                          institutional contacts (two or more instances
                          in the past 12 months or 90 days or greater)?
                        </b>
                      </Label>
                      <p className='label-font' name='reviewLengthyInst'>
                        {ahahLengthyRadio}
                        {
                          ahahLengthyRadio === 'Yes' &&
                          (
                            <>
                              {`, ${ahahLengthyFirstLast} has experienced frequent 
                              or lengthy institutional contacts as defined above.`}
                            </>
                          )
                        }
                      </p>
                    </Col>
                  </Row>

                  <hr className='mtb-35' />
                </>
              )
            }

            <Row>
              <Col sm="10">
                <h2 className="poppinsH2">
                  Signatures
              </h2>
              </Col>
              <Col sm="2">
                <NavLink exact to="/signature" className="editBtn btn btn-link">
                  Edit
              </NavLink>
              </Col>
            </Row>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Assessment reporter
          </h5>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewReportLast">
                  <b>
                    Last Name
                </b>
                </Label>
                <p className="label-font" name="sigReviewReportLast">
                  {assessmentReporter.reporterLast}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewReportFirst">
                  <b>
                    First Name
                </b>
                </Label>
                <p className="label-font" name="sigReviewReportFirst">
                  {assessmentReporter.reporterFirst}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewPosCred">
                  <b>
                    Position/Credentials
                </b>
                </Label>
                <p className="label-font" name="sigReviewPosCred">
                  {assessmentReporter.positionCred}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewProvLast">
                  <b>
                    Provider Agency Name
                </b>
                </Label>
                <p className="label-font" name="sigReviewProvLast">
                  {provAgencyName}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewRepSig">
                  <b>
                    Signature
                </b>
                </Label>
                <p className="label-font" name="sigReviewRepSig">
                  {assessmentReporter.signature}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" name="sigReviewRepDate">
                  <b>
                    Date
                </b>
                </Label>
                <p className="label-font" name="sigReviewRepDate">
                  {assessmentReporter.reporterDate !== '' ? moment(assessmentReporter.reporterDate).format("MM/DD/YYYY") : ''}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewReportEmail">
                  <b>
                    Email Address
                </b>
                </Label>
                <p className="label-font" name="sigReviewReportEmail">
                  {assessmentReporter.reporterEmail}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewReportPhone">
                  <b>
                    Phone Number
                </b>
                </Label>
                <p className="label-font" name="sigReviewReportPhone">
                  {assessmentReporter.reporterPhone}
                </p>
              </Col>
            </Row>

            <div className='spacer' />

            {
              assessmentCategories.indexOf("FCS-AHAH_accurate_info") >= 0 && 
              <div className='label-font'>
                I, the FCS-SH Provider, worked with my potential enrollee to share accurate information to the best of my knowledge 
                for the purpose of connecting the potential enrollee to the FCS and AHAH Rental Assistance Program.
              </div>
            }

            <div className="spacer" />

            <h5 className="poppinsH5">
              Assessment supervisor
          </h5>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewSupLast">
                  <b>
                    Last Name
                </b>
                </Label>
                <p className="label-font" name="sigReviewSupLast">
                  {assessmentSupervisor.supervisorLast}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewSupFirst">
                  <b>
                    First Name
                </b>
                </Label>
                <p className="label-font" name="sigReviewSupFirst">
                  {assessmentSupervisor.supervisorFirst}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewSupPosCred">
                  <b>
                    Position/Credentials
                </b>
                </Label>
                <p className="label-font" name="sigReviewSupPosCred">
                  {assessmentSupervisor.supervisorPosCred}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewSupSig">
                  <b>
                    Signature
                </b>
                </Label>
                <p className="label-font" name="sigReviewSupSig">
                  {assessmentSupervisor.superSignature}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewSupDate">
                  <b>
                    Date
                </b>
                </Label>
                <p className="label-font" name="sigReviewSupDate">
                  {assessmentSupervisor.supervisorDate !== '' ? moment(assessmentSupervisor.supervisorDate).format("MM/DD/YYYY") : ''}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <h5 className="poppinsH5">
              Enrollee information
          </h5>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" name="sigReviewEnrolleeLast">
                  <b>
                    Last Name
                </b>
                </Label>
                <p className="label-font" name="sigReviewEnrolleeLast">
                  {enrolleeInformation.enrolleeLast}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" name="sigReviewEnrolleeFirst">
                  <b>
                    First Name
                </b>
                </Label>
                <p className="label-font" name="sigReviewEnrolleeFirst">
                  {enrolleeInformation.enrolleeFirst}
                </p>
              </Col>
              <Col sm="4">
                <Label className="label-font" name="sigReviewEnrolleeDate">
                  <b>
                    Date
                </b>
                </Label>
                <p className="label-font" name="sigReviewEnrolleeDate">
                  {enrolleeInformation.enrolleeDate !== '' ? moment(enrolleeInformation.enrolleeDate).format("MM/DD/YYYY") : ''}
                </p>
              </Col>
            </Row>

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" htmlFor="sigReviewEnrolleeTime">
                  <b>
                    Time Consent Received
                </b>
                </Label>
                <p className="label-font" name="sigReviewEnrolleeTime">
                  {enrolleeInformation.time}
                </p>
              </Col>
              <Col sm="8">
                <Label className="label-font" name="sigReviewEnrolleeSig">
                  <b>
                    Signature
                </b>
                </Label>
                <p className="label-font" name="sigReviewEnrolleeSig">
                  {enrolleeInformation.enrolleeSignature}
                </p>
              </Col>
            </Row>

            <div className="spacer" />
            {
              signatureCategories.indexOf('I, the potential enrollee, confirm that all answers have been provided to the best of my knowledge.') >= 0 && 
              <div className='label-font'>
                {signatureCategories[signatureCategories.indexOf('I, the potential enrollee, confirm that all answers have been provided to the best of my knowledge.')]}
              </div>
            }

            <div className='spacer' />

            {
              signatureCategories.indexOf("shared with the Department of Commerce, landlords, property managers, and/or their third-part administrator") >= 0 && 
              <div className='label-font'>
                I understand that if I am selected for AHAH-RAP the information on this assessment will be shared with the Department of Commerce, 
                landlords, property managers, and/or their third-part administrator solely for the purposes of connecting me to housing 
                that aligns with my preferences and for program monitoring and evaluation.
              </div>
            }

            <div className='spacer' />

            {signatureCategories.indexOf('Verbal consent was received from the potential enrollee.') >= 0 &&
              <div className="label-font">
                {signatureCategories[signatureCategories.indexOf('Verbal consent was received from the potential enrollee.')]}
              </div>
            }

            <div className="spacer" />

            <Row>
              <Col sm="4">
                <Label className="label-font" name="sigReviewEnrolleeNotes">
                  <b>
                    Notes
                </b>
                </Label>
                <p className="label-font" name="sigReviewEnrolleeNotes">
                  {enrolleeInformation.enrolleeNotes}
                </p>
              </Col>
            </Row>

            <hr className="mtb-35" />

            <Row>
              <Col sm="10">
                <h2 className="poppinsH2">
                  Documentation
              </h2>
              </Col>
              <Col sm="2">
                <NavLink exact to="/documentation" className="editBtn btn btn-link">
                  Edit
              </NavLink>
              </Col>
            </Row>

            <div className="spacer" />

            <Label className='label-font' htmlFor='sigReviewDocuments'>
              <b>
                Documents
              </b>
            </Label>

            <div className='label-font' name='sigReviewDocuments'>
              {attachments.map(doc => (
                <>
                  <div key={doc.documentName}>
                    <span>
                      {doc.documentName}
                      &nbsp;-
                      <span>
                        {doc.fileName.slice(-3) === 'pdf' ?
                          <i className='icon icon-file-pdf' />
                          :
                          <i className='icon icon-file-image' />
                        }
                        {doc.fileName}
                      </span>
                    </span>
                  </div>
                  <div className='spacer' />
                </>
              ))}
            </div>

            <div className='spacer' />

            <div className="spacer" />

            <Label className="label-font" htmlFor="sigReviewDocuments">
              <b>
                Documentation Notes
            </b>
            </Label>
            <p className="label-font" name="sigReviewDocNotes">
              {documentNotes}
            </p>

            <div className="spacer-64" />

            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
          </Button>

            <div className="d-flex flex-row justify-content-end">
              <Button type="button" color="link" className="btn btn-link printBtn" onClick={this.printPage}>
                <i className="icon icon-print" />
                Print Assessment
            </Button>
              <Button type="button" color="primary" className="btn btn-primary nextBtn" onClick={this.handleSubmit}>
                Submit
            </Button>
            </div>
          </div>
          <div className="pb-spacerRem-4" />
        </div>
      </>
    );
  }
}

export default withNavigate(ReviewSubmit);

ReviewSubmit.propTypes = {
  navigate: PropTypes.func
};
